import { render, staticRenderFns } from "./paypal-buttons.vue?vue&type=template&id=4b29a88b&scoped=true&"
import script from "./paypal-buttons.vue?vue&type=script&lang=js&"
export * from "./paypal-buttons.vue?vue&type=script&lang=js&"
import style0 from "./paypal-buttons.vue?vue&type=style&index=0&id=4b29a88b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b29a88b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VOverlay})
